<template>
  <div id="pest-real" style="overflow:hidden; ">
    <div class="pestReal-data">
      <div class="pestReal-data-head">
        <div class="pestReal-head-left">
          <span class="pestReal-left-title">虫情实时数据</span>
        </div>
        <div class="pestReal-head-right">
          <div class="pestReal-right-select">
            设备名
            <el-select @change="pestRealChange($event)" v-model="defaultPestDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in pestOption"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="pestReal-data-content" style="overflow:auto;">
        <div class="pestReal-content-top">
          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div class="pestReal-content-imgOpt">
                <img src="../img/deviceID.png"/>
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>设备ID</span><br/><span>{{defaultPestDevice}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div class="pestReal-content-imgOpt">
                <img src="../img/deviceType.png"/>
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>设备类型</span><br/><span>虫情</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div class="pestReal-content-imgOpt">
                <img src="../img/deviceState.png"/>
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>设备状态</span><br/><span>{{deviceState}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div  class="pestReal-content-imgOpt">
                <img src="../img/pestDryTem.png">
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>烤箱温度</span><br/><span>{{pestTemp}}℃</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div  class="pestReal-content-imgOpt">
                <img src="../img/pestSplit.png">
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>雨水分离器</span><br/><span>{{pestRain}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div class="pestReal-content-imgOpt">
                <img src="../img/pestSun.png"/>
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>光控状态</span><br/><span>{{lightState}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div class="pestReal-content-imgOpt">
                <img src="../img/pestWea.png">
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>雨控状态</span><br/><span>{{rainState}}</span>
              </div>
            </div>
          </div>

          <div class="pestReal-content-topItem">
            <div class="pestReal-content-itemImg">
              <div  class="pestReal-content-imgOpt">
                <img src="../img/pestTime.png">
              </div>
            </div>
            <div class="pestReal-content-itemValue">
              <div class="pestReal-content-valueOpt">
                <span>更新时间</span><br/><span>{{updateTime}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="pestReal-content-main">
          <div class="pestReal-content-mainContainer">
            <div class="pestReal-main-left">
              <dv-border-box12>
                <div class="pestReal-mainLeft-title">
                  <span class="pestReal-mainLeft-titleOpt">系统控制</span>
                </div>

                <div class="pestReal-mainLeft-content">
                  <div class="pestReal-mainLeft-item">
                    <div class="pestReal-leftItem-container">
                      <div class="pestReal-leftItem-title">
                        <span class="pestReal-leftItem-titleOpt">画面控制模式</span>
                      </div>
                      <div class="pestReal-leftItem-value">
                        <div class="pestReal-leftItem-valueOpt">
                          <span style="cursor: pointer" @click="setControlMode">{{pestControlMode}}</span>
                        </div>
                      </div>
                    </div>
                   <div class="pestReal-leftItem-container">
                     <div class="pestReal-leftItem-title">
                       <span class="pestReal-leftItem-titleOpt">系统重启</span>
                     </div>
                     <div class="pestReal-leftItem-value">
                       <div class="pestReal-leftItem-valueOpt">
                         <span style=" cursor: pointer;" @click="setRestart">{{pestRestart}}</span>
                       </div>
                     </div>
                   </div>
                  </div>

                  <div class="pestReal-mainLeft-item" style="margin-top: 3%">
                    <div class="pestReal-leftItem-container">
                      <div class="pestReal-leftItem-top">
                        <span class="pestReal-leftItem-topOpt">总工作时长(>30)</span>
                      </div>
                      <div class="pestReal-leftItem-middle">
                        <el-input v-model="workTime" placeholder="120" class="pestReal-leftItem-middleOpt"></el-input>
                      </div>
                      <div class="pestReal-leftItem-bottom">
                        <el-button type="primary" plain @click="setWorkTime">修改</el-button>
                      </div>
                    </div>
                    <div class="pestReal-leftItem-container">
                      <div class="pestReal-leftItem-top">
                        <span class="pestReal-leftItem-topOpt">拍照周期(>15)</span>
                      </div>
                      <div class="pestReal-leftItem-middle">
                        <el-input v-model="capturePeriod" placeholder="60" class="pestReal-leftItem-middleOpt"></el-input>
                      </div>
                      <div class="pestReal-leftItem-bottom">
                        <el-button type="primary" plain @click="setCapturePeriod">修改</el-button>
                      </div>
                    </div>
                  </div>

                  <div class="pestReal-mainLeft-item" style="margin-top: 3%">
                    <div class="pestReal-leftItem-container">
                      <div class="pestReal-leftItem-title">
                        <span class="pestReal-leftItem-titleOpt">工作回路</span>
                      </div>
                      <div class="pestReal-leftItem-value">
                        <div class="pestReal-leftItem-valueOpt">
                          <span style=" cursor: pointer;" @click="setPestOnPower">{{pestOnPower}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="pestReal-leftItem-container">
                      <div class="pestReal-leftItem-title">
                        <span class="pestReal-leftItem-titleOpt">工作回路</span>
                      </div>
                      <div class="pestReal-leftItem-value">
                        <div class="pestReal-leftItem-valueOpt">
                          <span style=" cursor: pointer;" @click="setPestOffPower">{{pestOffPower}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </dv-border-box12>
            </div>

            <div class="pestReal-main-right">
              <dv-border-box12>
                <div class="pestReal-mainRight-title">
                  <span class="pestReal-mainRight-titleOpt">画面控制</span>
                </div>

                <div class="pestReal-mainRight-content">
                  <div class="pestReal-mainRight-item">
                    <div class="pestReal-RightItem-container">
                      <div class="pestReal-RightItem-title">
                        <span class="pestReal-RightItem-titleOpt">诱虫灯</span>
                      </div>
                      <div class="pestReal-RightItem-value">
                        <div class="pestReal-RightItem-valueOpt">
                          <span style=" cursor: pointer;" @click="setPestLight">{{pestLight}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="pestReal-RightItem-container">
                      <div class="pestReal-RightItem-title">
                        <span class="pestReal-RightItem-titleOpt">摄像头</span>
                      </div>
                      <div class="pestReal-RightItem-value">
                        <div class="pestReal-RightItem-valueOpt">
                          <span style=" cursor: pointer;" @click="setPestPhoto">拍照</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="pestReal-mainRight-item" style="margin-top: 3%">
                    <div class="pestReal-RightItem-container">
                      <div class="pestReal-RightItem-title">
                        <span class="pestReal-RightItem-titleOpt">补光灯</span>
                      </div>
                      <div class="pestReal-RightItem-value">
                        <div class="pestReal-RightItem-valueOpt">
                          <span style=" cursor: pointer;" @click="setPestCamLight">{{pestCamLight}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="pestReal-RightItem-container">
                      <div class="pestReal-RightItem-title">
                        <span class="pestReal-RightItem-titleOpt">灭活</span>
                      </div>
                      <div class="pestReal-RightItem-value">
                        <div class="pestReal-RightItem-valueOpt">
                          <span style=" cursor: pointer;" @click="setPestHot">{{pestHot}}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="pestReal-mainRight-item" style="margin-top: 3%">
                    <div class="pestReal-RightItem-container">
                      <div class="pestReal-RightItem-title">
                        <span class="pestReal-RightItem-titleOpt">落虫</span>
                      </div>
                      <div class="pestReal-RightItem-value">
                        <div class="pestReal-RightItem-valueOpt">
                          <span style="cursor: pointer" @click="setPestFill">{{pestFill}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="pestReal-RightItem-container">
                      <div class="pestReal-RightItem-title">
                        <span class="pestReal-RightItem-titleOpt">清虫</span>
                      </div>
                      <div class="pestReal-RightItem-value">
                        <div class="pestReal-RightItem-valueOpt">
                          <span style="cursor: pointer" @click="setPestClear">{{pestClear}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </dv-border-box12>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SporeAnalyseData from "./SporeAnalyseData";
  import {
    bathDeviceDo,
    modWormAutoMode, pestCurrentState,
    pestDeviceState,
    wormAutoMode,
    wormMode,
    wormOper
  } from "../../until/api/SporePest";
  export default {
    name: 'PestRealData',
    components: {SporeAnalyseData},
    data() {
      return {
        pestOption:[],
        defaultPestDevice: '',
        bePestDevice: '',
        deviceState: '-',
        lightState: '-',
        rainState: '-',
        pestTemp: '-',
        pestRain: '-',
        updateTime: '',
        workTime: '',
        capturePeriod: '',
        pestRestart: '启动',
        pestControlMode: '-',
        pestOnPower: '开启',
        pestOffPower: '关闭',
        pestLight: '',
        pestCamLight: '',
        pestHot: '',
        pestFill: '',
        pestClear: '',
        pestTime: null,
      }
    },

    mounted() {
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      if(authority != 'TENANT_ADMIN') {
        this.getPestDevice(customerId); //获取虫情设备
      }
    },

    beforeDestroy() {
      //清空时间
      clearInterval(this.pestTime);
      this.pestTime = null;
      //切换画面时关闭下发模式
      if(this.pestControlMode == '开启') {
        let param = {"deviceId":this.defaultPestDevice, "orderType":"controlMode", "orderValue":"XC+STOPTEST"};
        console.log("关闭下发模式", param);
        this.$SporePestCommon.setPestOrder(param, function (response) {
          console.log("关闭下发模式状态", response.data)
        })
      }
    },

    methods: {
      /**
       * 获取虫情设备
       * @param customerId
       */
      getPestDevice(customerId) {
        let that = this;
        this.$MeteSoilCommon.getCustomerData(customerId, function (response) {
          for(let i = 0; i<response.data.length; i++) {
            if(response.data[i].key.toString().indexOf('pest') > -1) {
              let jsonPest = JSON.parse(response.data[i].value);
              that.pestOption.push({"deviceAddr": jsonPest.name, "deviceName": jsonPest.name});
            }
          }
          if(that.pestOption.length > 0) {//取得虫情设备
            that.defaultPestDevice = that.pestOption[0].deviceAddr; //默认虫情设备
            that.bePestDevice = that.pestOption[0].deviceAddr;//默认上次虫情设备
            that.pestRealDataTime(); //获取实时数据
          }
        })
      },

      /**
       * 切换设备
       * @param event
       */
      pestRealChange(event) {
        //清空时间
        clearInterval(this.pestTime);
        this.pestTime = null;
        //切换设备时关闭上一个设备下发模式
        if(this.pestControlMode == '开启') { //上个设备下发模式开启时关闭
          let that = this;
          let param = {"deviceId":this.bePestDevice, "orderType":"controlMode", "orderValue":"XC+STOPTEST"};
          console.log("关闭下发模式", param);
          this.$SporePestCommon.setPestOrder(param, function (response) {//关闭上个设备下发模式
            that.defaultPestDevice = event;
            that.bePestDevice = event;
            that.pestRealDataTime();//获取实时数据
            that.pestControlMode = '关闭';
            console.log("关闭下发模式状态", response.data)
          })
        } else {//上个下发模式未开启
          this.defaultPestDevice = event;
          this.bePestDevice = event;
          this.pestRealDataTime();//获取实时数据
          this.pestControlMode = '关闭';
        }
      },

      /**
       * 获取实时数据
       */
      pestRealDataTime() {
        pestDeviceState(this.defaultPestDevice).then(response => {
          this.pestControlMode = '关闭';
          this.pestSetRealData(response); //设置实时数据1
          this.pestSystemData(); //设置实时数据2
        }).catch(error => {
          console.log("error", error);
        });

        //每隔5分钟刷新一次实时数据
        this.pestTime = window.setInterval(() => {
          setTimeout(() => {
            pestDeviceState(this.defaultPestDevice).then(response => {
              this.pestSetRealData(response); //设置实时数据1
              this.pestSystemData();  //设置实时数据2
            }).catch(error => {
              console.log("error", error)
            })
          },0)
        }, 1000 * 60 * 5)
      },

      /**
       * 设置实时数据1
       * @param response
       */
      pestSetRealData(response) {
        this.deviceState = response.data.data.online == 1 ? '在线' : '离线';
        this.lightState = response.data.data.lightStatus == 1 ? '白天' : '晚上';
        this.rainState = response.data.data.rainStatus == 1 ? '下雨' : '晴天';
        this.updateTime =  response.data.data.updateTime.substring(0, 10) + " " +  response.data.data.updateTime.substring(11, 19);
        this.pestLight = response.data.data.pestLight == '1' ? '开启' : '关闭';
        this.pestCamLight = response.data.data.camLight == '1' ? '开启' : '关闭';
        this.pestHot = response.data.data.hot == '1' ? '开启' : '关闭';
        this.pestFill = response.data.data.pestFill == '1' ? '开启' : '关闭';
        this.pestClear = response.data.data.pestClear == '1' ? '开启' : '关闭';
      },

      /**
       * 设置实时数据2
       */
      pestSystemData() {
        pestCurrentState(this.defaultPestDevice).then(response => {
          if(response.data.code == 200) {
            this.pestTemp = response.data.data.temperatureSensor;
            this.pestRain = response.data.data.rainServo == 1 ? '接雨' : '接虫';
            this.workTime = response.data.data.totalWorkHours;
            this.capturePeriod = response.data.data.captureCycle;
          } else {
            this.pestTemp = '-';
            this.pestRain = '-';
            this.workTime = '';
            this.capturePeriod = '';
          }

        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 更改画面控制模式
       */
      setControlMode() {
        this.$confirm('请确定是否更改画面控制模式', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(this.pestControlMode == '关闭') { //开启设备下发模式
            let that = this;
            let param = {"deviceId":this.defaultPestDevice, "orderType":"controlMode", "orderValue":"XC+STARTTEST"};
            console.log("进入下发模式", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) { //进入下发模式成功
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '设备进入下发模式成功'
                })
                that.pestControlMode = '开启';
              } else { //进入下发模式失败
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '设备进入下发模式失败'
                })
              }
            })
          } else { //关闭设备下发模式
            let that = this;
            let param = {"deviceId":this.defaultPestDevice, "orderType":"controlMode", "orderValue":"XC+STOPTEST"};
            console.log("退出下发模式", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.$message({ //关闭下发模式成功
                  showClose: true,
                  type: 'success',
                  message: '设备退出下发模式成功'
                })
                that.pestControlMode = '关闭';
              } else { //关闭下发模式失败
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '设备退出下发模式失败'
                })
              }
            })
          }
        }).catch(() => {
          this.$message({
            showClose: true,
            type: 'warning',
            message: '更改画面控制模式已取消'
          })
        })
      },

      /**
       *系统重启
       */
      setRestart() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否进行系统重启', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //系统重启
            let that = this;
            let param = {"deviceId":this.defaultPestDevice, "orderType":"reboot", "orderValue":"XC+REBOOT"};
            console.log("系统重启", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '系统重启成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '系统重启失败'
                })
              }
            })
          }).catch(() => { //系统重启取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '系统重启已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 开启工作回路
       */
      setPestOnPower() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否开启工作回路', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //开启工作回路
            let that = this;
            let param = {"deviceId":this.defaultPestDevice, "orderType":"devicePower", "orderValue":"XC+POWER=ON"};
            console.log("开启工作回路", param)
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '开启工作回路成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '开启工作回路失败'
                })
              }
            })
          }).catch(() => { //开启工作回路取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '开启工作回路已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 关闭工作回路
       */
      setPestOffPower() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否关闭工作回路', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //关闭工作回路
            let that = this;
            let param = {"deviceId":this.defaultPestDevice, "orderType":"devicePower", "orderValue":"XC+POWER=OFF"};
            console.log("关闭工作回路", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '关闭工作回路成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '关闭工作回路失败'
                })
              }
            })
          }).catch(() => { //关闭工作回路取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '关闭工作回路已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 设置总工作时长
       */
      setWorkTime() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          let time = 'XC+TOL=' + this.workTime;
          let param = {"deviceId": this.defaultPestDevice, "orderType": "workTime", "orderValue": time};
          console.log("总工作时长", param);
          let that = this;
          this.$SporePestCommon.setPestOrder(param, function (response) {
            if(response.data.code == 200) {
              that.$message({
                showClose: true,
                type: 'success',
                message: '总工作时长设置成功'
              })
            } else {
              that.$message({
                showClose: true,
                type: 'warning',
                message: '总工作时长设置失败'
              })
            }
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
        // this.$message({
        //   showClose: true,
        //   type: 'success',
        //   message: '总工作时长设置成功'
        // })
      },

      /**
       * 设置拍摄周期
       */
      setCapturePeriod() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          let time = 'XC+CC=' + this.capturePeriod;
          let param = {"deviceId": this.defaultPestDevice, "orderType": "capturePeriod", "orderValue": time};
          console.log("拍摄周期", param);
          let that = this;
          this.$SporePestCommon.setPestOrder(param, function (response) {
            if(response.data.code == 200) {
              that.$message({
                showClose: true,
                type: 'success',
                message: '拍照周期设置成功'
              })
            } else {
              that.$message({
                showClose: true,
                type: 'warning',
                message: '拍照周期设置失败'
              })
            }
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 设置诱虫灯状态
       */
      setPestLight() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否更改诱虫灯状态', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //更改补光灯状态
            let opt = this.pestLight == '关闭' ? 'XC+L=1' : 'XC+L=0';
            let param = {"deviceId": this.defaultPestDevice, "orderType":"command", "orderValue":opt};
            let that = this;
            console.log("更改诱虫灯状态", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200){
                that.pestLight = that.pestLight == '关闭' ? '开启' : '关闭';
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '诱虫灯' + that.pestLight + '状态修改成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '更改诱虫灯状态失败'
                })
              }
            })

          }).catch(() => { //更改补光灯状态取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改诱虫灯状态已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 立即拍照
       */
      setPestPhoto() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否立即拍照', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //拍照
            let param = {"deviceId": this.defaultPestDevice, "orderType":"command", "orderValue": "XC+CAPTURE"};
            console.log("拍照", param);
            let that = this;
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '拍照成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '拍照失败'
                })
              }
            })
          }).catch(() => { //拍照取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '拍照已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 设置补光灯状态
       */
      setPestCamLight() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否更改补光灯状态', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //更改补光灯状态
            let opt = this.pestCamLight == '关闭' ? 'XC+CL=1' : 'XC+CL=0';
            let param = {"deviceId": this.defaultPestDevice, "orderType":"command", "orderValue":opt};
            let that = this;
            console.log("更改补光灯状态", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.pestCamLight = that.pestCamLight == '关闭' ? '开启' : '关闭';
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '补光灯' + that.pestCamLight + '状态修改成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '更改补光灯状态失败'
                })
              }
            })
          }).catch(() => { //更改补光灯状态取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改补光灯状态已取消'
            })
          })

        } else {//当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 设置灭活状态
       */
      setPestHot() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否更改灭活状态', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { //更改灭活状态
            let opt = this.pestHot == '关闭' ? 'XC+HOT=1' : 'XC+HOT=0';
            let param = {"deviceId": this.defaultPestDevice, "orderType":"command", "orderValue":opt};
            let that = this;
            console.log("更改灭活状态", param)
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.pestHot = that.pestHot == '关闭' ? '开启' : '关闭';
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '灭活' + that.pestHot + '状态修改成功'
                })
              } else {
                this.$message({
                  showClose: true,
                  type: 'warning',
                  message: '更改灭活状态失败'
                })
              }
            })
          }).catch(() => { //更改灭活状态取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改灭活状态已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 设置落虫状态
       */
      setPestFill() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否更改落虫状态', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => { //更改落虫状态
            let opt = this.pestFill == '关闭' ? 'XC+UP=1' : 'XC+UP=0';
            let param = {"deviceId": this.defaultPestDevice, "orderType":"command", "orderValue":opt};
            let that = this;
            console.log("更改落虫状态", param);
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.pestFill = that.pestFill == '关闭' ? '开启' : '关闭';
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '落虫' + that.pestFill + '状态修改成功'
                })
              } else {
                that.$message({
                  showClose: true,
                  type: 'warning',
                  message: '更改落虫状态失败'
                })
              }
            })
          }).catch(() => { //更改落虫状态已取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改落虫状态已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启画面控制模式'
          })
        }
      },

      /**
       * 设置清虫状态
       */
      setPestClear() {
        if(this.pestControlMode == '开启') { //判断当前是否进入下发模式
          this.$confirm('请确定是否更改清虫状态', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type:'warning'
          }).then(() => { //更改清虫状态
            let opt = this.pestClear == '关闭' ? 'XC+DOWN=1' : 'XC+DOWN=0';
            let param = {"deviceId": this.defaultPestDevice, "orderType":"command", "orderValue":opt};
            console.log("清虫状态", param);
            let that = this;
            this.$SporePestCommon.setPestOrder(param, function (response) {
              if(response.data.code == 200) {
                that.pestClear = that.pestClear == '关闭' ? '开启' : '关闭';
                that.$message({
                  showClose: true,
                  type: 'success',
                  message: '清虫' + that.pestClear + '状态修改成功'
                })
              } else {
                this.$message({
                  showClose: true,
                  type: 'warning',
                  message: '更改清虫状态失败'
                })
              }
            })
          }).catch(() => { //更改清虫状态已取消
            this.$message({
              showClose: true,
              type: 'warning',
              message: '更改清虫状态已取消'
            })
          })
        } else { //当前未进入下发模式
          this.$message({
            showClose: true,
            type: 'warning',
            message: '请先开启化画面控制模式'
          })
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../less/PestRealData";
</style>

<style>
  .pestReal-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/PestRealData.vue